export interface ConversionCampaign {
    uuid: string;
    name: string,
    validation_period: number,
    commission_type: 'fixed' | 'percent',
    commission_target: string,
    min_commission: number,
    max_commission: number,
    img_url: string,
    url: string,
    payout_categories?: PayoutCategory[]
    terms?: string[],
    description?: string,
    reporting_type?: 'realtime' | 'offline',
    reporting_period?: number,
    payment_period?: number,
    deeplink_allowed?: boolean
}

export interface PayoutCategory {
    name: string,
    type: 'percent' | 'fixed',
    payout: string | number
}

export interface ConversionCampaignFilters {
    page: number,
    q?: string
}

export interface ConversionCampaignSlice {
    filters:ConversionCampaignFilters,
    applied_filter_id: string | null,
    filtered_list: Record<string,  //FilterId
        {
            list: ConversionCampaign[]; 
            count: number; 
            page: number,
            last_fetched_at: number | null,
            expired: boolean,
            has_more: boolean
        }
    >
    list: ConversionCampaign[]; 
    count: number; 
    loading: boolean;
    last_fetched_at: number | null;
    page: number;
    has_more: boolean;
    expired: boolean;
    items: Record<string, {
        campaign: ConversionCampaign;
        last_fetched_at: number;
    }>,
    itemLoading: boolean,
    linksLoading: boolean,
    links: Record<string, {
        list: ConversionCampaignLink[];
        last_fetched_at: number;
        has_more: boolean;
        count: number;
        page: number
    }>
    commissionsLoading: boolean,
    commissions: {
        list: ConversionCampaignCommission[];
        last_fetched_at: number | null;
        has_more: boolean;
        count: number;
        page: number
    }
}

export interface ConversionCampaignCommission {
    status: 'accepted' | 'rejected' | 'pending' | 'paid',
    commission_amount: number,
    currency: string,
    created: string,
    created_at: string,
    campaign: ConversionCampaign
}

export const ConversionCampaignCommissionStatusLabel = {
    accepted: 'Accepted',
    rejected: 'Rejected',
    pending: 'Pending',
    paid: 'Paid'
}

export interface ConversionCampaignLink {
    id: number, 
    url: string,
    short_url: string,
    short_url_code: string,
    visits: number,
    thumbnail_url?: string | null,
    title?: string | null
}

export interface ConversionCampaignListResponse {
    count: number;
    items: ConversionCampaign[];
}

export interface ConversionCampaignCommissionsResponse {
    count: number;
    items: ConversionCampaignCommission[];
}

export interface ConversionCampaignLinksResponse {
    count: number;
    items: ConversionCampaignLink[];
}